<div class="global-loader" *ngIf="loaderService.loading$ | async">
  <div class="spinner"></div>
</div>
<router-outlet></router-outlet>
